import { createTheme } from "@mui/material/styles";

const BASE_THEME = createTheme({
  palette: {
    mode: "light",
    primary: {
      light: "#d9e9ff",
      main: "#2563eb",
      dark: "#1e40af",
    },
    secondary: {
      light: "#ccfbf1",
      main: "#0f766e",
      dark: "#115e59",
    },
    error: {
      main: "#b91c1c",
    },
    warning: {
      main: "#b45309",
    },
    success: {
      main: "#15803d",
    },
    info: {
      main: "#0284c7",
    },
    custom: {
      light: "#e2e8f0",
      main: "#64748b",
      dark: "#334155",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    divider: "#e2e8f0",
    background: {
      default: "#f8fafc",
      paper: "#ffffff",
    },
    text: {
      light: "#64748b",
      main: "#475569",
      default: "#0f172a",
      secondary: "#334155",
      dark: "#020617",
    },
  },
  typography: {
    fontFamily: '"Manrope", "Segoe UI", "Helvetica Neue", sans-serif',
    fontSize: 14,
    fontWeight: 400,
    h1: {
      fontWeight: 700,
      fontSize: 34,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontWeight: 700,
      fontSize: 28,
      letterSpacing: "-0.02em",
    },
    h3: {
      fontWeight: 700,
      fontSize: 22,
    },
    h4: {
      fontWeight: 700,
      fontSize: 18,
    },
    h5: {
      fontSize: 16,
      fontWeight: 700,
    },
    h6: {
      fontSize: 14,
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: 16,
      fontWeight: 600,
      fontStyle: "normal",
    },
    subtitle2: {
      fontSize: 13,
      fontWeight: 600,
      fontStyle: "normal",
      letterSpacing: "0.02em",
      textTransform: "uppercase",
    },
    body1: {
      fontSize: 14,
      fontStyle: "normal",
      lineHeight: 1.55,
    },
    body2: {
      fontSize: 12,
      fontStyle: "normal",
      lineHeight: 1.5,
    },
    button: {
      fontSize: 14,
      textTransform: "none",
      fontWeight: 600,
    },
    caption: {
      fontSize: 12,
      color: "#64748b",
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: ({ theme }) =>
          theme.unstable_sx({
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
          }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: "8px 14px",
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 10px 18px rgba(37, 99, 235, 0.18)",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: "#ffffff",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderWidth: 2,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: "#475569",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: 8,
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          borderRadius: 16,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#f8fafc",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          border: "1px solid #e2e8f0",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
  },
});

export default BASE_THEME;
